<template>
    <div>
        <h1>{{ $t('labels.edit_teams') }}</h1>

        <div class="row">
            <div class="col">
                <label class="switch mr-3">
                    <input type="checkbox" :checked="teamsAsButtons" @click="$store.dispatch('toggleTeamsAsButtons')">
                    <span class="slider round"></span>
                </label>

                <span class="pt-2" v-text="$t('labels.teams_as_buttons')"></span>
            </div>
        </div>

        <div class="row row-scrollable" v-if="teamsAsButtons">
            <div class="col-sm-6">
                <h5 v-text="$t('labels.shown')"></h5>
                <draggable class="list-group list-group--draggable list-group--scrollable" tag="ul" v-model="visible" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                    <transition-group type="transition" :name="'flip-list'">
                        <li class="list-group-item" v-for="team in visible" :key="team.id" :style="'background:' + (team.color ? team.color: '#FFFFFF')">
                            <span class="js-handle">::</span>
                            {{ team.name }}
                        </li>
                    </transition-group>
                </draggable>
            </div>

            <div  class="col-sm-6">
                <h5 v-text="$t('labels.hidden')"></h5>
                <draggable class="list-group list-group--draggable list-group--scrollable" tag="ul" v-model="hidden" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                    <transition-group :name="'flip-list'" type="transition">
                        <li class="list-group-item" v-for="team in hidden" :key="team.id" :style="'background:' + (team.color ? team.color: '#FFFFFF')">
                            <span class="js-handle">::</span>
                            {{ team.name }}
                        </li>
                    </transition-group>
                </draggable>
            </div>
        </div>

        <div class="app-actions">
            <div class="col-sm-6">
                <button class="btn btn-secondary btn--xl" @click="reset"><font-awesome-icon :icon="['fas', 'sync']" class="mr-2" /> {{ $t('labels.reset') }}</button>
            </div>

            <div class="col-sm-6 text-right">
                <button class="btn btn-primary btn--xl" @click="close">{{ $t('labels.close') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'teams',

  components: {draggable},

  data() {
    return {
      visible: [],
      hidden: [],
      editable: true,
      isDragging: false,
      delayedDragging: false
    };
  },

  computed: {
    currentDevice() {
      return this.$store.state.currentDevice
    },

    currentLocation() {
      return this.$store.state.currentLocation;
    },

    teamsAsButtons() {
      return this.$store.state.teamsAsButtons;
    },

    teamsOrder() {
      return this.$store.state.teamsOrder;
    },

    teams() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.$store.state.teams.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
    },

    dragOptions() {
      return {
        handle: ".js-handle",
        animation: 150,
        group: 'teams',
        disabled: !this.editable,
        ghostClass: 'ghost'
      };
    },

    listVisible() {
      return this.visible.map(team => team.id).join('|');
    },

    listHidden() {
      return this.hidden.map(team => team.id).join('|');
    }
  },

  watch: {
    isDragging(newValue) {
      if (newValue) return this.delayedDragging = true;

      this.$nextTick(() => {
        this.delayedDragging = false;
      })
    },

    listVisible(order) {
      this.$store.dispatch('setTeamsOrder', order);
    }
  },

  methods: {
    onMove({relatedContext, draggedContext}) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    },

    reset() {
      this.$store.commit('clearTeamsOrder');
      this.$store.commit('setChecked');
    },

    close() {
      let navbar = this.$parent.$children.find(item => item.$options.name === 'navbar');

      if (!navbar) return this.$router.go(-1);

      return window.setTimeout(() => this.$router.go(-1), 300);
    }
  },

  mounted() {
    window.events.$emit('disableNumpad');

    if (this.$store.getters.currentEmployee === null || this.$store.getters.currentEmployee === undefined) {
      return this.$router.push({name: 'pin'});
    }

    let main = document.querySelector('.app-main');
    let sidebar = document.querySelector('.app-sidebar');

    main.classList.add('app-main--fullscreen');
    sidebar.style.display = 'none';

    window.events.$emit('setFullscreen', true);

    const ordered = this.teamsOrder
        ? this.teamsOrder.split('|')
        : this.currentDevice && this.currentDevice.teams_order ? this.currentDevice.teams_order : [];

    this.visible = this.teams
        .filter(team => ordered.indexOf(team.id.toString()) > -1)
        .map(team => {
          team.order = ordered.indexOf(team.id.toString());

          return team;
        })
        .sort((a, b) => {
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });

    this.hidden = this.teams.filter(team => ordered.indexOf(team.id.toString()) === -1);
  },

  beforeDestroy() {
    window.events.$emit('setFullscreen', false);

    let main = document.querySelector('.app-main');
    let sidebar = document.querySelector('.app-sidebar');

    main.classList.remove('app-main--fullscreen');
    sidebar.style.display = 'flex';
  }
}
</script>

<style scoped>

    .actions--fixed {
        height: calc(100% - 40px);
    }

    .actions--fixed > div {
        overflow: scroll;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: .5;
        background: #C8EBFB;
    }
    .list-group {
        min-height: 20px;
    }
    .list-group--draggable {
        height: 100%;
        background: rgba(255,255,255,.75);
    }
    .list-group--draggable > span {
        height: 100%;
    }
    .list-group-item {
        padding: 0.75rem 1.25rem .75rem 0;
        cursor: move;
    }
    .list-group-item i{
        cursor: pointer;
    }

    .js-handle {
        cursor: move;
        cursor: -webkit-grabbing;
        padding: .75rem 1.25rem;
    }
</style>
